// src/Api/signupApi.js
import { post } from "./api";
import { useState } from "react";

const useSignup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const signup = async (formData) => {
    setLoading(true);
    setError(null);

    try {
      const response = await post("/signup", formData);
      setData(response);
      return response;
    } catch (error) {
      // ✅ Specific error handling
      if (
        error?.response?.status === 409 ||
        error?.response?.data?.message === "email already registered"
      ) {
        setError("email already registered"); // 👈 custom message
      } else {
        setError(error?.response?.data?.message || "Signup failed");
      }
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { signup, loading, error, data };
};

export default useSignup;
